import { render } from "./sendOutDialog.vue?vue&type=template&id=37d21fe5"
import script from "./sendOutDialog.vue?vue&type=script&lang=js"
export * from "./sendOutDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__